export default __webpack_public_path__ + "static/media/home_explain_export_import.448ed381.png";